import { useSyncExternalStore } from 'react'

// Mirrors the Tailwind `md` breakpoint (768px) already used everywhere else in this app to
// draw the mobile/desktop line (the hamburger vs. nav-pill row, TopBar/CanvasContainer's
// narrow-viewport checks, etc.), so "mobile" here means the same thing it means in the rest
// of the UI. Read via useSyncExternalStore, same pattern as useHoverCapable.
const MOBILE_QUERY = '(max-width: 767px)'

function subscribe(callback: () => void) {
  const mq = window.matchMedia(MOBILE_QUERY)
  mq.addEventListener('change', callback)
  return () => mq.removeEventListener('change', callback)
}

function getSnapshot() {
  return window.matchMedia(MOBILE_QUERY).matches
}

function getServerSnapshot() {
  return false
}

export function useIsMobile() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
